<app-fn-ui-navigation-actions-tree [treeConfig]="treeConfig"
                                   [treeModel]="tree?.favorites"
                                   [selectedNode]="selectedNode"
                                   [leafActions]="menuActions"
                                   (nodeActionClicked)="onMenuItemClick($event)">
</app-fn-ui-navigation-actions-tree>
